import React, { useMemo, useState } from 'react'
import './about-product.scss'
import SpinWithMessage from '../../common/spinners/SpinWithMessage'
import { customerAxios } from '../../../config/axios'
import toast from 'react-hot-toast'
import Modal from '../../common/modal/Modal'
import CUParentProduct from './CUParentProduct'


const AboutParentProduct = ({ productCode }) => {
    const [loading, setLoading] = useState('')
    const [data, setData] = useState({})
    const [modal, setModal] = useState({})

    useMemo(() => {
        setLoading('fetch')
        customerAxios.get(`/production-v0/parent-product/${productCode}`)
            .then((response) => {
                setData(response.data || {})
                setLoading('')
            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })

    }, [productCode])

    const openEditModel = () => {
        setModal({
            status: true, title: "Edit product", width: '600px',
            content: <CUParentProduct currentData={data} setModal={setModal} setData={setData} isEdit={true} />
        })
    }

    const handleChangeStatus = () => {
        const ask = window.confirm(`Are you ready to ${data?.is_active ? 'Inactive' : "Active"} ?`)

        if (ask) {
            customerAxios.patch(`/production-v0/parent-product/${data?.product_code}/status`, {
                is_active: data?.is_active ? false : true
            }).then(() => {
                setModal({ status: false })
                toast.success(`Status Updated!`)

                setData({
                    ...data,
                    is_active: data?.is_active ? false : true
                })

            }).catch((error) => {
                toast.error(error.message)
            })
        }
    }

    return (
        loading === 'fetch'
            ? <SpinWithMessage message='Loading...' height={'250px'} />
            : <div className="about-product-container">
                <Modal modal={modal} setModal={setModal} />
                <div className="buttons">
                    <button onClick={() => openEditModel()}>Edit Product</button>
                    <button style={{ backgroundColor: data?.is_active ? 'red' : "green" }} onClick={handleChangeStatus}>
                        {data?.is_active ? 'Deactivate' : "Activate"}
                    </button>
                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Parent Product</h4>
                    </div>
                    <div className="title-content">
                        <div className="list-div">
                            <div className="one-div">
                                <p>Product Code</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.product_code}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Product Name</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.product_name}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Category</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.product_category}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Brand</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.brand}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Service Enabled</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.is_service_product
                                    ? 'Yes'
                                    : "No"
                                }</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Rental Enabled</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.is_rental_product
                                    ? 'Yes'
                                    : "No"
                                }</p>
                            </div>
                        </div>

                        <div className="list-div">
                            <div className="one-div">
                                <p>Warranty Period</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.warranty_period ? `${data?.warranty_period} Months` : "Nil"} </p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Tax</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.tax?.tax_percentage ? `${data?.tax?.tax_percentage}% (GST)` : "Not Setup"} </p>
                            </div>
                        </div>

                        <div className="list-div credit-amt">
                            <div className="one-div">
                                <p>Status</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.is_active ? 'ACTIVE' : "INACTIVE"}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Attribute Labels</h4>
                    </div>
                    {data?.attributes?.length > 0
                        ? <>
                            <div className="title-content">
                                {data?.attributes?.map((attr) => {
                                    return <div className="list-div">
                                        <div className="one-div">
                                            <p>{attr?.label} </p>
                                        </div>
                                        <div className="two-div">
                                            <p>{attr?.variant ? ' : Variant' : ''}</p>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </>
                        : <p>Nil</p>}
                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Spares</h4>
                    </div>
                    {data?.spares?.length > 0
                        ? <>
                            <div className="title-content">
                                {data?.spares?.map((sp) => {
                                    return <div className="list-div">
                                        <div className="one-div">
                                            <p>{sp?.spare_id}</p>
                                        </div>
                                        <div className="two-div">
                                            <p>: {sp?.spare_name} - {sp?.spare_category} (Qty : {sp?.qty})</p>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </>
                        : <p>Nil</p>}
                </div>
            </div>
    )
}

export default AboutParentProduct